import { JobPipelineService } from '../../services/job-pipeline-service';
import Global from '../../store/global-selectors';
import { genericErrorHandlingForScanToPrint } from '../../store/scan-to-print/s2p-purchase-and-print.actions';
import { resetScanToPrintMode } from '../../store/scan-to-print/scan-to-print.actions';

// Steps
import FinalizeFulfillmentPlan from './steps/finalize-fulfillment-plan';
import CreateLabel from './steps/create-label';
import PrintScanToPrintLabel from './steps/print-scan-to-print-label';

export const SCAN_TO_PRINT_PURCHASE_AND_PRINT = 'SCAN_TO_PRINT_PURCHASE_AND_PRINT';

const pipeline = [FinalizeFulfillmentPlan, CreateLabel, PrintScanToPrintLabel];

JobPipelineService.registerPipeline(SCAN_TO_PRINT_PURCHASE_AND_PRINT, {
  pipeline,
  initialData: {},
  onExit: (jobId, state) => {
    const jobData = Global.selectJobPipelineJobDataByJobId(state, { jobId });
    const { errors, labelBatchIds } = jobData;
    if (errors) {
      return genericErrorHandlingForScanToPrint(errors, labelBatchIds);
    }

    const queue = Global.selectScanToPrintQueue(state);
    if (queue?.isActive) {
      // Don't reset when queue is active - let the epic handle advancement
      return null;
    }

    return resetScanToPrintMode();
  },
});
